import * as EventConstants from "../constants/event.constant";
import { Loading } from "../utils/helpers/constants";
import { modifyList } from "../utils/helpers/dataHelper";

const initialState = {
  events: [],
  event: {},
  createEventLoading: false,
  creator: {},
  eventLoading: false,
  eventListLoading: "",
  eventStatusLoading: false,
  joinEventLoading: "",
  eventAttendeesLoading: "",
  attendees: [],
  modal: false,
  userAttendee: false,
};

const setLoading = (state, action) => {
  const actionLoading = { ...state.communityStatusLoading };
  const { loading, id } = action.payload;
  actionLoading[id] = loading;
  return actionLoading;
};

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case EventConstants.CREATE_EVENT_REQUEST:
      return { ...state, createEventLoading: Loading.FETCHING };
    case EventConstants.CREATE_EVENT_SUCCESS:
      return {
        ...state,
        ...action.payload,
        event: action.payload,
        createEventLoading: Loading.SUCCESS,
        modal: true,
      };
    case EventConstants.CREATE_EVENT_FAILURE:
      return { ...state, createEventLoading: Loading.ERROR };

    case EventConstants.JOIN_EVENT_REQUEST:
      return { ...state, joinEventLoading: Loading.FETCHING };

    case EventConstants.JOIN_EVENT_SUCCESS:
      return {
        ...state,
        userAttendee: true,
        joinEventLoading: Loading.SUCCESS,
      };

    case EventConstants.JOIN_EVENT_FAILURE:
      return { ...state, joinEventLoading: Loading.ERROR };

    case EventConstants.LEAVE_EVENT_REQUEST:
      return { ...state, joinEventLoading: Loading.FETCHING };

    case EventConstants.LEAVE_EVENT_SUCCESS:
      return {
        ...state,
        userAttendee: false,
        joinEventLoading: Loading.SUCCESS,
      };

    case EventConstants.LEAVE_EVENT_FAILURE:
      return { ...state, joinEventLoading: Loading.ERROR };

    case EventConstants.FETCH_ALL_EVENT_REQUEST:
      return { ...state, eventListLoading: Loading.FETCHING };
    case EventConstants.FETCH_ALL_EVENT_SUCCESS:
      return {
        ...state,
        events: action.payload,
        eventListLoading: Loading.SUCCESS,
      };
    case EventConstants.FETCH_ALL_EVENT_FAILURE:
      return { ...state, eventListLoading: Loading.ERROR };

    case EventConstants.FETCH_EVENT_REQUEST:
      return { ...state, loading: Loading.FETCHING };
    case EventConstants.FETCH_EVENT_SUCCESS:
      return {
        ...state,
        event: action.payload,
        eventLoading: Loading.SUCCESS,
        creator: action.payload.creator,
        userAttendee: action.payload.userAttendee,
      };
    case EventConstants.FETCH_EVENT_FAILURE:
      return { ...state, loading: Loading.ERROR };

    case EventConstants.FETCH_EVENT_ATTENDEES_REQUEST:
      return { ...state, eventAttendeesLoading: Loading.FETCHING };
    case EventConstants.FETCH_EVENT_ATTENDEES_SUCCESS:
      return {
        ...state,
        ...action.payload,
        attendees: action.payload,
        eventAttendeesLoading: Loading.SUCCESS,
      };
    case EventConstants.FETCH_EVENT_ATTENDEES_FAILURE:
      return { ...state, eventAttendeesLoading: Loading.ERROR };

    case EventConstants.EVENT_APPROVAL_REQUEST:
      return { ...state, eventStatusLoading: setLoading(state, action) };
    case EventConstants.EVENT_APPROVAL_SUCCESS:
      const eventList = [...state.events];
      const modifiedList = modifyList(
        eventList,
        action.payload.id,
        "id",
        "approved"
      );
      return {
        ...state,
        events: modifiedList,
        eventStatusLoading: setLoading(state, action),
      };
    case EventConstants.EVENT_APPROVAL_FAILURE:
      return { ...state, eventStatusLoading: setLoading(state, action) };

    case EventConstants.CLOSE_EVENT_MODAL_REQUEST:
      return {
        ...state,
        modal: false,
      };

    default:
      return state;
  }
};

export default eventReducer;
